<template>
  <div>
    <v-app-bar
      ref="nav_top_bar"
      :extended="false"
      :height="navTopBarHeight"
      app
      color="#FFFFFF"
      elevation="0"
      class="top-bar"
    >
      <p class="top-bar__title" style="margin-left: 70px">{{ title }}</p>
      <v-spacer/>
      <div class="top-bar-username">
        {{ userNameForTopBar }}
      </div>
      <v-menu
        bottom
        left
        nudge-bottom="50"
        nudge-left="40"
        v-model="showMenu"
        :close-on-content-click="false"
        min-width="750px"
        v-if="['ADMIN_ROLE'].includes(currentRole)"
      >
        <!--        ['ADMIN_ROLE', 'ORGANIZATION_ROLE']-->
        <template #activator="{on, attrs }">
          <!-- Верхнее меню   -->
          <span v-bind="attrs" v-on="on" class="top-bar__menu" @mouseenter="showMenu = !showMenu">
            <v-btn icon><img src="@/assets/icons/menu.svg" alt="menu"></v-btn>
          </span>
        </template>
        <v-card style="overflow-y: auto; max-height: 100vh">
          <v-card-text class="sidebar-right-menu ">
            <template v-if="['ADMIN_ROLE'].includes(currentRole)">
              <h2 class="sidebar-right-menu__link-section off">Установление объемов КЦП ВО</h2>
              <v-divider style="width: 100%" class="mt-3 mb-1"/>
              <template v-for="item in navigationRightListFiltered1">
                <router-link
                  v-if="item.path || item.name"
                  :key="item.path || item.name"
                  :to="{name: item.name, path: item.path}"
                  exact
                  exact-active-class="sidebar-right-menu__link_active"
                  class="sidebar-right-menu__link"
                >
                  {{ item.text }}
                </router-link>
                <div
                  v-else
                  @click="handleFunctionCall(item.functionName)"
                  :key="item.text"
                  class="sidebar-right-menu__link"
                >
                  {{ item.text }}
                </div>
              </template>
            </template>
            <template v-if="['ORGANIZATION_ROLE'].includes(currentRole)">
              <template v-for="item in navigationRightListFiltered1">
                <template v-if="item.additionalHeader">
                  <h2 :key="item.path + item.name + 'head'" class="sidebar-right-menu__link-section off">
                    {{ item.additionalHeader }}
                  </h2>
                  <v-divider :key="item.path + item.name + 'divider'" style="width: 100%" class="mt-3 mb-1"/>
                </template>
                <router-link
                  v-if="item.path || item.name"
                  :key="item.path + item.name"
                  :to="{name: item.name, path: item.path}"
                  exact
                  exact-active-class="sidebar-right-menu__link_active"
                  class="sidebar-right-menu__link"
                >
                  {{ item.text }}
                </router-link>
                <div
                  v-else
                  @click="handleFunctionCall(item.functionName)"
                  :key="item.text"
                  class="sidebar-right-menu__link"
                >
                  {{ item.text }}
                </div>
              </template>
            </template>
          </v-card-text>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      :fixed="true"
      :width="navDrawerWidth"
      mobile-breakpoint="300"
    >
      <div :style="`min-height: ${navTopBarHeight}px!important`" class="sidebar-logo">
        <router-link to="/">
          <img alt="logo" src="../../assets/icons/Logo_ined.svg">
        </router-link>
      </div>
      <nav>
        <div class="sidebar">
          <v-row no-gutters style="">
            <v-col>
              <router-link
                :to="{name: 'contacts'}" class="d-flex flex-row align-center"
                exact exact-active-class="sidebar-div__active-alternate"
              >
                <img class="sidebar__profile-img" alt="profile" src="@/assets/icons/profile.svg">
                <div v-if="showNavigation" class="sidebar-profile">{{ userName }}</div>
              </router-link>
            </v-col>
          </v-row>
          <transition name="slide-fade">
            <div>
              <router-link
                v-for="route in navigationLeftListFiltered"
                :key="route.name !== 'instructions' ? route.path + route.name : 'instructions'"
                :to="route.name !== 'instructions' ? {name: route.name, path: route.path} : route.path"
                exact exact-active-class="sidebar-div__active"
              >
                <div
                  class="sidebar-div sidebar-cursor"
                  :data-tooltip="route.text"
                  @click="handleFunctionCall(route.functionName)"
                >
                  <a href="#" class="sidebar-img">
                    <img
                      :alt="route.alt"
                      :src="`${require('@/assets/'+route.src + '.svg')}`"
                    >
                    <!--                    <img-->
                    <!--                      v-if="hover[route.hoverName]"-->
                    <!--                      :alt="route.alt"-->
                    <!--                      :src="`${require('@/assets/'+route.srcHover + '.svg')}`"-->
                    <!--                    >-->
                  </a>
                  <p v-if="showNavigation" class="sidebar-text">{{ route.text }}</p>
                </div>
              </router-link>
              <div
                v-if="getFakeUser"
                class="sidebar-div sidebar-cursor"
                @mouseout="hover.exitOrg = false"
                @mouseover="hover.exitOrg = true"
                @click.prevent="logoutFakeUser"
              >
                <a href="#" class="sidebar-img">
                  <v-icon size="24" :color="hover.exitOrg ? '#EB722E' : 'primary'">mdi-exit-to-app</v-icon>
                </a>
                <p v-if="showNavigation" class="sidebar-text">Выход из организации</p>
              </div>
              <div
                class="sidebar-div sidebar-cursor"
                @mouseout="hover.exit = false"
                @mouseover="hover.exit = true"
                @click.prevent="logout"
              >
                <a href="#" class="sidebar-img">
                  <img alt="exit" src="@/assets/icons/navBar/exit.png">
                  <!--                  <img v-if="hover.exit" alt="exit" src="@/assets/icons/navBar/exit-hover.png">-->
                </a>
                <p v-if="showNavigation" class="sidebar-text">Выход</p>
              </div>
            </div>
          </transition>
        </div>
      </nav>
      <div
        class="sidebar-toggle"
        @mouseout="hover.toggle = false" @mouseover="hover.toggle = true"
        @click="showNavigation = !showNavigation"
      >
        <img v-if="showNavigation" alt="toggle" src="@/assets/icons/sidebar-toggle-on.svg">
        <!--        <img v-if="hover.toggle && showNavigation" alt="toggle" src="@/assets/icons/sidebar-toggle-on_hover.svg">-->
        <img v-if="!showNavigation" alt="toggle" src="@/assets/icons/sidebar-toggle-off.svg">
        <!--        <img v-if="hover.toggle && !showNavigation" alt="toggle" src="@/assets/icons/sidebar-toggle-off_hover.svg">-->
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {OKCPList, OrganizationList} from "@/components/Navigation/navRigthList";
import {
  FounderLeftList,
  LeftListFixed,
  OrganizationLeftList,
} from "@/components/Navigation/navLeftList";
import {hasAddKcpCheck} from "@/api/indicators"

// const title = 'КЦП на 2024/25 учебный год';
export default {
  name: "navBar",
  data() {
    return {
      hover: {
        exit: false,
        exitOrg: false,
        main: false,
      },
      showNavigation: false,
      navigationLeftList: [
        ...OrganizationLeftList,
        ...LeftListFixed,
      ],
      navigationRightList: [
        ...OKCPList,
        ...OrganizationList,
      ],
      navigationLeftListAccred: FounderLeftList,
      showMenu: false,
      navTopBarHeight: 60,
      hasAddKcp: false
    }
  },
  computed: {
    ...mapGetters('keycloak', {
      getAuthData: 'getAuthData',
      getRoles: 'getRoles',
      isAdmin: 'isAdmin',
      isRegion: 'isRegion',
      isCO: 'isCO',
      isOrganization: 'isOrganization',
      getFakeUser: 'getFakeUser',
      currentRole: 'currentRole'
    }),
    ...mapGetters('checkFilled', {currentStage: 'currentStage'}),
    navDrawerWidth() {
      return this.showNavigation ? 324 : 70
    },
    title() {
      if (this.isRegion && !this.isAdmin) {
        return this.$route.meta.title ? this.$route.meta.title : 'Согласование общих объемов КЦП на 2024/2025 учебный год'
      } else {
        return 'Согласование общих объемов КЦП на 2024/2025 учебный год'
      }
    },
    navigationLeftListFiltered() {
      const data = this.navigationLeftList.filter(el => this.checkRole(el.roles));
      if (this.currentStage > 3 && this.currentRole === 'FOUNDER_ROLE') {
        return this.navigationLeftListAccred;
      }

      if (this.currentStage > 3 && this.currentRole === 'CO_ROLE') {
        data.unshift(this.navigationLeftListAccred[0])
      }

      if (this.getAuthData?.founderID !== 8 && this.getFakeUser?.id !== 8) {
        const index = data.findIndex(el => el.text === 'Согласование с регионами');
        index !== -1 ? data.splice(index, 1) : null // только для минкульта, удаление 'Согласование с регионами'
      }

      if (this.currentStage < 5) {
        const index1 = data.findIndex(el => el.text === 'Сводные оценки заявок');
        index1 !== -1 ? data.splice(index1, 2) : null // удаление ['Сводные оценки заявок', 'Распределение КЦП']
      }

      if ((this.currentStage !== 7 && !this.isAdmin) || !this.hasAddKcp) {
        const index1 = data.findIndex(el => el.name === 'AllListStage1CorrectValues');
        index1 !== -1 ? data.splice(index1, 1) : null // удаление ['Согласование дополнительных объемов КЦП']
      }

      if (this.currentStage !== 8 || !this.isRegion) {
        const index1 = data.findIndex(el => el.name === 'AllListRegion');
        index1 !== -1 ? data.splice(index1, 1) : null
      }
      return data
    },
    navigationRightListFiltered1() {
      return this.navigationRightList.filter(el => this.checkRole(el.roles))
    },
    userName() {
      return this.getAuthData?.given_name
    },
    userNameForTopBar() {
      if (this.getFakeUser)
        return this.getFakeUser.name
      return this.getAuthData?.given_name
    },
  },
  created() {
    this.hasAddKcpCheckFunc();
  },
  watch: {
    currentStage() {
      this.stageCheckAndPath()
    }
  },
  methods: {
    ...mapActions('keycloak', {keycloakLogout: 'keycloakLogout', clearFakeUser: 'clearFakeUser'}),
    ...mapActions('checkFilled', {clearBlockInfo: 'clearBlockInfo'}),
    async hasAddKcpCheckFunc() {
      this.hasAddKcp = await hasAddKcpCheck();
    },
    async stageCheckAndPath() {
      setTimeout(this.myFunction, 1000);
    },
    myFunction() {
      console.log(this.currentStage, this.isRegion, this.$route.path);
      if (this.currentStage === 8 && this.isRegion && !this.isAdmin && this.$route.path === '/') {
        this.$router.push({name: 'AllListRegion'});
      }
    },
    checkRole(roles) {
      let accept = false;
      for (const role of roles) {
        if ((this.getRoles && this.getRoles.includes(role) && this.currentRole === role) || this.getFakeUser?.role === role)
          accept = true;
      }
      return accept
    },
    logoutFakeUser() {
      if (this.getFakeUser.role === 'CO_ROLE')
        this.$router.push({name: 'co'});
      if (this.getFakeUser.role === 'FOUNDER_ROLE')
        this.$router.push({name: 'founders'});
      if (this.getFakeUser.role === 'REGION_ROLE')
        this.$router.push({name: 'regions'});
      if (this.getFakeUser.role === 'ORGANIZATION_ROLE')
        this.$router.push({name: 'organizations'});
      this.clearBlockInfo()
      this.clearFakeUser();
    },
    logout() {
      this.keycloakLogout();
    },
    downloadInstruction() {
      const a = document.createElement('a');

      if ((this.isRegion && !this.getFakeUser) || this.getFakeUser?.role === 'REGION_ROLE') {
        a.href = 'https://files.ined.ru/files/kcp2023/instruction_subjects_stage.pdf'
      } else if ((this.isCO && !this.getFakeUser) || this.getFakeUser?.role === 'CO_ROLE') {
        a.href = 'https://files.ined.ru/files/kcp2023/instruction_co_stage.pdf'
      } else if ((this.isOrganization && !this.getFakeUser) || this.getFakeUser?.role === 'ORGANIZATION_ROLE') {
        a.href = 'https://files.ined.ru/files/kcp2024/instruction_2024.pdf'
      }

      a.target = '_blank';
      a.click();
      a.remove();
    },
    handleFunctionCall(functionName) {
      if (functionName !== undefined) {
        this[functionName]()
      }
    }
  },
}
</script>

<style lang="sass">
.v-navigation-drawer
  transition: opacity 1.5s

.slide-fade-enter-active
  transition: all .8s ease

.slide-fade-enter, .slide-fade-leave-to
  opacity: 0

#app
  ::-webkit-scrollbar
    width: 6px

  ::-webkit-scrollbar-track
    box-shadow: inset 0 0 6px #CFE0EC

  ::-webkit-scrollbar-thumb
    background-color: #00599B
    border-radius: 10px

.sidebar-cursor
  cursor: url(../../assets/icons/cursor.svg), auto

.sidebar-logo img
  cursor: url(../../assets/icons/cursor.svg), auto
  margin-top: 19px
  margin-left: 24px
</style>